const isString = (val: any) => Object.prototype.toString.call(val) === "[object String]";
const RFC2822_REGEX = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;
const REQUIRED = (val: any) => isString(val) && val?.length > 0;
const EMAIL = (val: any) => isString(val) && RFC2822_REGEX.test(val);

const validate = (formData: FormData) => ($node: HTMLElement) => {
	const fieldName = $node.getAttribute('name') ?? '';
	const validationName = $node.dataset.validate;
	const value = formData.get(fieldName);
	let isValid = true;

	switch (validationName) {
		case 'required':
			isValid = REQUIRED(value);
			break;
		case 'email':
			isValid = EMAIL(value);
			break;
		default:
			console.warn('no validation method:', validationName);
			break
	}

	$node.dataset.isInvalid = isValid ? 'false' : 'true';
	return isValid;
}

export default ($node: HTMLElement) => {
	const $form: HTMLFormElement|null = $node.querySelector('form');

	if ($form) {
		let hasBeenSubmitted = false;
		const endpointUri = $form.dataset.endpointUri ?? '';
		const validatableFields = Array.from($form.querySelectorAll('[data-validate]'));

		const onSubmit = (e: Event) => {
			e.preventDefault();
			e.stopPropagation();

			const formData = new FormData($form);
			const isValid = validatableFields
				.map(validate(formData))
				.every(Boolean);

			if (!hasBeenSubmitted && isValid) {
				hasBeenSubmitted = true;
				fetch(endpointUri, {
					method: 'POST',
					body: formData,
				})
				.then(response => {
					$node.dataset.status = response.ok ? 'success' : 'failed';
				});
			}
		};

		$form.addEventListener('submit', onSubmit, false);
	}
}
